import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
  itemId: string;
};

const removeProductFromCart: ServiceMethod<void, Params> =
  (httpClient) => async (data, options) => {
    const { cartId, itemId } = data;

    const { body: response } = await httpClient.delete<void, Params, undefined>(
      '/api/v3/carts/{cartId}/items/{itemId}',
      {
        ...options,
        params: {
          cartId,
          itemId,
        },
      }
    );

    return response;
  };

export default removeProductFromCart;
